export enum LoginResultType {
  OK,
  INVALID,
  ERROR,
}
